module.exports = __webpack_public_path__ + "media/fanfare.0b4d06f1.wav";